import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HipobuyGuide from "../pages/hipobuy-guide/page";
import HipobuyDebutant from "@/pages/seo/hipobuy-debutant/page";
import HipobuyVsGoogleSheets from "@/pages/seo/hipobuy-vs-google-sheets/page";
import Top10Templates from "@/pages/seo/top-10-templates/page";
import ErreursAEviter from "@/pages/seo/erreurs-a-eviter/page";
import GuideDebutantComplet from "@/pages/seo/guide-debutant-complet/page";
import AutomatisationAvancee from "@/pages/seo/automatisation-avancee/page";
import SecuriteConfidentialite from "@/pages/seo/securite-confidentialite/page";
import OptimiserWorkflow from "@/pages/seo/optimiser-workflow/page";
import GuideAchatProduits from "@/pages/seo/guide-achat-produits/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-guide",
    element: <HipobuyGuide />,
  },
  {
    path: "/hipobuy-debutant",
    element: <HipobuyDebutant />,
  },
  {
    path: "/hipobuy-vs-google-sheets",
    element: <HipobuyVsGoogleSheets />,
  },
  {
    path: "/top-10-templates",
    element: <Top10Templates />,
  },
  {
    path: "/erreurs-a-eviter",
    element: <ErreursAEviter />,
  },
  {
    path: "/guide-debutant-complet",
    element: <GuideDebutantComplet />,
  },
  {
    path: "/automatisation-avancee",
    element: <AutomatisationAvancee />,
  },
  {
    path: "/securite-confidentialite",
    element: <SecuriteConfidentialite />,
  },
  {
    path: "/optimiser-workflow",
    element: <OptimiserWorkflow />,
  },
  {
    path: "/guide-achat-produits",
    element: <GuideAchatProduits />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;